export interface IStorageDecodedCredentials {
  id: string;
  uuid: string;
  token: string;
  role: string;
  projectId: string;
}
